import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query"; 
import { productService } from "../../../services/product"; 
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import { Toolbar } from "primereact/toolbar";
import DispatchDetails from "../DispatchDetails";
import formatDate from "../../../components/ui/dateFormat";
import useDebounce from "../../../components/ui/useDebounce";
import { Paginator } from "primereact/paginator";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

export default function SysDispatchProducts() {
  const [first, setFirst] = useState(0);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState("");
  const filterChange = (e) => {
    setFilter(e.target.value);
  };
  const debouncedFilter = useDebounce(filter, 600);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setPage(event.page + 1);
  };

  const { data: apiResponse, isLoading } = useQuery({
    queryKey: ["dispatchProducts", page, rows, debouncedFilter],
    queryFn: () =>
      productService.getAllDispatchProducts(page, rows, debouncedFilter),
  });
  useEffect(() => {
    const totalRecords = apiResponse?.totalRecords || 0;
    setTotalRecords(totalRecords);
  }, [apiResponse]);

  const products = Array.isArray(apiResponse?.data) ? apiResponse.data : [];

  const [visible, setVisible] = useState(false); 
  const [dataRow, setRowData] = useState(null);
 
   const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
  };
  const mtBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkMt);
  };
  const kgBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkKg);
  }; const partiBodyTemplate = (rowData) => {
    return (<div>{rowData.belgeNo} / {rowData.parti}</div>);
  };
  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.sevkTar);
  };
  const cols = [
    { field: "sevkTar", header: "Tarih", body: dateBodyTemplate },
    { field: "unvan", header: "Firma" },
    { field: "urun", header: "Ürün" },
    { field: "kodu", header: "İşlem" },
    { field: "belgeNo", header: "Parti No",body:partiBodyTemplate }, 
    { field: "sevkKg", header: "Kg" ,body:kgBodyTemplate},
    { field: "sevkMt", header: "Mt",body:mtBodyTemplate },
  ];
  const viewRow = (rowData) => { 
    setVisible(true);
    setRowData(rowData);
  };

  const actionBodyTemplate = (rowData) => {
    return <Button type="button" icon="pi pi-eye"  loading={isLoading}  text size="large"  
     onClick={() => viewRow(rowData)} rounded></Button>;
  };

   

 
const footer = (
    <Paginator
    first={first}
    rows={rows}
    totalRecords={totalRecords}
    rowsPerPageOptions={[10, 30, 50]}
    onPageChange={onPageChange}
    className="p-0 m-0 border-none"
    disabled={isLoading} // Yüklenme sırasında paginator'ı devre dışı bırak
  />
  );

  return (
    <div  >
        <DispatchDetails
        setVisible={setVisible}
        visible={visible}
        dataRow={dataRow} 
      />
    
            <Toolbar
                  className="shadow-3 border-round-md  my-2"
                  start={
                    <div className="text-2xl font-bold"> Tüm Hazır Ürünler</div>
                  }
                  end={
                    <IconField iconPosition="left">
                      <InputIcon className="pi pi-search" />
                      <InputText
                        type="search"
                        value={filter || ""}
                        className="w-full"
                        onChange={(e) => filterChange(e)}
                        placeholder="Ara"
                      />
                    </IconField>
                  }
                />
 
        <DataTable loading={isLoading} 
           size="medium"     className="shadow-3 border-round-md table-content surface-ground" 
              scrollable scrollHeight="flex"
          emptyMessage="Liste Boş"
          footer={footer}
          value={products || []} 
        >
          {cols.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              body={col.body}
            />
          ))}
          <Column
            headerStyle={{ width: "5rem", textAlign: "center" }}
            bodyStyle={{ textAlign: "center", overflow: "visible" }}
            body={actionBodyTemplate}
          />
        </DataTable>
      
    </div>
  );
}
